import api from '@/configurations/service';
import { mapState } from 'vuex';
import { MODELO } from '../enums/Documento';

export default {
  data() {
    return {
      series: [],
    };
  },
  computed: {
    ...mapState('pdv', ['satTransmitter']),
  },
  methods: {
    async getSeries(modelo = 65) {
      let documento = modelo;

      if (!Array.isArray(this.satTransmitter)) {
        documento = MODELO.SAT;
      }

      const { data } = await api(2).post('/fiscal.get-configurations-by-client', {
        documentos: [documento],
        withoutDevices: true,
        active: true,
      });

      this.series = data.map((e) => e.serie);
    },
  },
};
